/* @flow */

import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Paper from '@material-ui/core/Paper';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//

import ActionDrawerWrapper from 'components/ActionDrawerWrapper/ActionDrawerWrapper';
import ActionsList from 'components/ActionsList/ActionsList';
import Activity from 'components/Activity/Activity';
import AdditionalInfo from 'components/AdditionalInfo/AdditionalInfo';
import Loading from 'components/Loading/Loading';
import PageTitle from 'components/PageTitleLegacy/PageTitle';
import PageWrapper from 'components/PageWrapper/PageWrapper';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator';

//----------------------------------------------------------------------//
// LOCAL COMPONENTS                                                     //
//----------------------------------------------------------------------//

import {
  ArchiveCostCenter,
  UnarchiveCostCenter,
  AssignProjects,
  RemoveProjects,
  ToggleCostCenterStatus,
} from 'views/ActionDrawer';

import styles from 'common-scss/DetailsPage.module.scss';

import AssignedToCostCenter from './components/AssignedToCostCenter/AssignedToCostCenter';
import CostCenterDetails from './components/CostCenterDetails/CostCenterDetails';

import actionsListData from './actionsListData';
import { generateUrl, costCentre } from 'api/routes';

@translate()
@inject('actionDrawerStore', 'costCenterDetailsStore', 'navigationStore')
@observer
export default class CostCenterDetailsPage extends React.Component<*> {
  componentDidMount() {
    this.props.costCenterDetailsStore.loadDetails(this.props.match.params.id);
    this.props.navigationStore.reset();
    this.props.navigationStore.pushPath(0, '/cost-centers');
    this.props.navigationStore.pushPath(1, this.props.location.pathname);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      costCenterDetailsStore,
      match,
    }: { costCenterDetailsStore: Object, match: Object } = this.props;

    if (costCenterDetailsStore.details && costCenterDetailsStore.details.id !== match.params.id) {
      costCenterDetailsStore.loadDetails(match.params.id, false);
    }

    if (prevProps.actionDrawerStore.loadParent) {
      costCenterDetailsStore.loadDetails(match.params.id, false);
      this.props.actionDrawerStore.loadParent = false;
    }
  }

  render() {
    const t: Function = this.props.t;
    const detailsStore: observable = this.props.costCenterDetailsStore;

    if (!detailsStore.details) {
      return <Loading />;
    }

    const title: string = `${t('general:cost_center')} | ${detailsStore.details.name}`;

    return (
      <React.Fragment>
        <PageWrapper isFlex={false}>
          <PageTitle title={title} />
          <div className={styles['grid-wrapper']}>
            <Paper className={styles['feature-item']}>
              <div className={styles['details-panel']}>
                <CostCenterDetails details={detailsStore.details} />
                <AssignedToCostCenter details={detailsStore.details} />
                <AdditionalInfo title="general:cost_center" details={detailsStore.details} />
              </div>

              <div className={styles['actions-panel']}>
                <StatusIndicator
                  title={t('general:cost_centers.labels.status')}
                  status={
                    detailsStore.details.archived_at
                      ? 'Archived'
                      : detailsStore.details.status
                      ? 'Active'
                      : 'Disabled'
                  }
                />
                <ActionsList actions={actionsListData} data={detailsStore.details} />
              </div>
            </Paper>
            <Paper className={styles['activity-panel']}>
              {this.props.match.params.id && (
                <Activity
                  title={true}
                  url={generateUrl(costCentre.activity, [this.props.match.params.id])}
                  refresh={this.props.actionDrawerStore.success}
                  allowFilter={true}
                />
              )}
            </Paper>
          </div>
        </PageWrapper>
        <ActionDrawerWrapper
          appendActionToURL={true}
          onActionCompleted={() => {
            /*overriding with empty fn*/
          }}
        >
          {
            {
              assignProjectsToCC: <AssignProjects costCenter={detailsStore.details} />,
              removeProjectsFrommCC: <RemoveProjects costCenter={detailsStore.details} />,
              archiveCostCenter: <ArchiveCostCenter formData={detailsStore.details} />,
              toggleCostCenterStatus: <ToggleCostCenterStatus costCenter={detailsStore.details} />,
              unarchiveCostCenter: <UnarchiveCostCenter formData={detailsStore.details} />,
            }[this.props.actionDrawerStore.currentActionDrawer]
          }
        </ActionDrawerWrapper>
      </React.Fragment>
    );
  }
}
